'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactSocial = require('react-social');

var _ = require('../');

var _PetitionRotatingTweet = require('./PetitionRotatingTweet.css');

var _PetitionRotatingTweet2 = _interopRequireDefault(_PetitionRotatingTweet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PetitionRotatingTweet = (_dec = (0, _reactCssModules2.default)(_PetitionRotatingTweet2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PetitionRotatingTweet, _Component);

  function PetitionRotatingTweet(props) {
    (0, _classCallCheck3.default)(this, PetitionRotatingTweet);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PetitionRotatingTweet.__proto__ || (0, _getPrototypeOf2.default)(PetitionRotatingTweet)).call(this, props));

    _this.state = {
      companyName: props.companyName,
      tweets: props.tweets,
      url: props.url
    };
    return _this;
  }

  (0, _createClass3.default)(PetitionRotatingTweet, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          companyName = _state.companyName,
          tweets = _state.tweets,
          url = _state.url;


      var randomTweet = tweets[Math.floor(Math.random() * tweets.length)];

      return _react2.default.createElement(
        'div',
        { styleName: 'take-action-share' },
        _react2.default.createElement(
          'div',
          { styleName: 'take-action-label' },
          _react2.default.createElement(
            'h2',
            null,
            'Send a Tweet to ',
            companyName
          ),
          _react2.default.createElement(
            'p',
            null,
            'Send a Tweet to ',
            companyName,
            ' letting them know how you feel.'
          ),
          _react2.default.createElement(
            'blockquote',
            { styleName: 'take-action-blockquote' },
            randomTweet.jsx
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'take-action-icons' },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _reactSocial.TwitterButton,
              {
                title: 'Send Tweet',
                message: randomTweet.plainText,
                url: url,
                element: 'a'
              },
              _react2.default.createElement(
                'p',
                null,
                'Send Tweet'
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_.LinkIcon, { nospace: true, faclass: 'fa-twitter-square' })
              )
            )
          )
        )
      );
    }
  }]);
  return PetitionRotatingTweet;
}(_react.Component), _class2.propTypes = {
  companyName: _react.PropTypes.string.isRequired,
  tweets: _react.PropTypes.array.isRequired,
  url: _react.PropTypes.string.isRequired
}, _temp)) || _class);
exports.default = PetitionRotatingTweet;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PetitionRotatingTweet/PetitionRotatingTweet.js
// module id = 1392
// module chunks = 0